module.exports = __webpack_public_path__ + "img/footer-m@2x.04223c67.png";